import { AbstractControl, FormGroup, ValidationErrors, ValidatorFn } from "@angular/forms";
import * as moment from "moment";

export function passwordConfirmationValidator(matchingControl: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const forbidden = control.parent?.get(matchingControl)?.value !== control.value;
        return forbidden ? { 'passwordConfirmation': { value: control.value } } : null;
    };
}

export function emailValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        if (!control.value) return null

        const matches = control.value?.match(/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/);
        return !matches ? { 'emailValidation': { value: control.value } } : null;
    };
}

export function futureDateTimeValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        if (!control.value) return null

        let valid = moment().diff(moment(control.value), 'seconds') <= 0;

        return !valid ? { 'futureDateValidation': { value: control.value } } : null;
    };
}

export function validDateTypeValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        if (!control.value) return null

        let valid = moment(control.value);

        return !valid.isValid() ? { 'dateTypeValidation': { value: control.value } } : null;
    };

}
export const startBeforeExpiryValidator: ValidatorFn = (
  control: AbstractControl
): ValidationErrors | null => {
  const start = control.get('sheet_start_time')?.value;
  const expiry = control.get('expiry_time')?.value;

  if (!start || !expiry) {
    return null; // let required validators handle empty values
  }

  return start < expiry ? null : { startAfterExpiry: true };
};
